import React, { useState, useEffect } from "react";
import { getUserProfile, updateUserProfile } from "../api/user";
import { useModal } from "../context/ModalContext";
import { Link } from "react-router-dom";
import GIF from "../assets/approved.gif";

const API_URL = process.env.REACT_APP_API_URL || "https://backend.hunarmandpunjab.org.pk";

const OnsiteDashboard = () => {
  const { showError } = useModal();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [profile, setProfile] = useState(null);
  const [challans, setChallans] = useState([]);
  const [formData, setFormData] = useState({
    fullName: "",
    fatherName: "",
    mobile: "",
    dateOfBirth: "",
    gender: "",
    qualification: "",
    permanentAddress: "",
    city: "",
  });
  const [successMsg, setSuccessMsg] = useState("");

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getUserProfile();
      if (response.data?.success || response.status === "success" || response.data) {
        const data = response.data?.data || response.data || response;
        const u = data.user;
        setProfile(u);
        setChallans(data.challans?.challans || []);

        let formattedDob = "";
        if (u.dateOfBirth) {
          formattedDob = new Date(u.dateOfBirth).toISOString().split("T")[0];
        }

        setFormData({
          fullName: u.fullName || "",
          fatherName: u.fatherName || "",
          mobile: u.mobile || "",
          dateOfBirth: formattedDob,
          gender: u.gender || "",
          qualification: u.qualification || "",
          permanentAddress: u.permanentAddress || "",
          city: u.city || "",
        });
      }
    } catch (err) {
      console.error("Failed to load profile:", err);
      showError("Failed to load candidate profile details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccessMsg("");
    try {
      const response = await updateUserProfile(formData);
      if (response.data?.success || response.data?.status === "success" || response.status === 200 || response.success) {
        setSuccessMsg("Profile updated successfully!");
        // Clear message after 5 seconds
        setTimeout(() => setSuccessMsg(""), 5000);
        fetchData();
      } else {
        showError(response.data?.message || "Failed to update profile.");
      }
    } catch (err) {
      console.error("Failed to update profile:", err);
      showError(err.response?.data?.message || "Server error while updating profile.");
    } finally {
      setSaving(false);
    }
  };

  const handleDownloadPDF = async (challanId) => {
    try {
      const fileUrl = `${API_URL}/api/onsite/challan/${challanId}/pdf`;
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to fetch PDF");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `challan-${challanId}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Blob download failed, fallback to direct open:", err);
      window.location.href = `${API_URL}/api/onsite/challan/${challanId}/pdf`;
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
        <div className="spinner-border text-success" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#f8f9fa", minHeight: "100vh" }}>
      <div className="register py-5">
        <div className="container" style={{ maxWidth: "1000px" }}>

          {/* Congratulations Banner */}
          <center className="pt-2">
            <img style={{ width: "100px" }} src={GIF} alt="approved" />
          </center>

          <h2 className="text-center mt-3 mb-4 fw-bold">
            🎉 Congratulations! You've Successfully Submitted Your Onsite Application
          </h2>

          <div
            className="alert alert-warning border-0 shadow-sm mb-4 text-center p-3"
            style={{ backgroundColor: "#fff3cd", color: "#664d03", fontFamily: "Poppins" }}
            role="alert"
          >
            <h4 className="fw-bold mb-2 fs-5">🎓 Hunarmand Punjab Scholarship Entry Test 2026</h4>
            <p className="mb-2 fw-semibold" style={{ fontSize: "0.95rem" }}>
              In collaboration with Punjab University, offering industry-focused training in AI, Digital Marketing, Web Development and Ethical Hacking.
            </p>
            <p className="mb-0 text-muted" style={{ fontSize: "0.9rem" }}>
              Pay your Entry Test Fee today to unlock scholarship opportunities, laptops, electric bikes and monthly stipends.
            </p>
          </div>

          <div
            className="alert alert-success mt-4 mb-4 border-0 shadow-sm"
            style={{ color: "#0f5132", fontFamily: "Poppins", backgroundColor: "#d1e7dd" }}
            role="alert"
          >
            <p className="mb-3">
              <strong>Your onsite application has been successfully submitted.</strong>
            </p>
            <p className="mb-3">
              Please note: Admission to the onsite classes is subject to successfully passing the Entry Test. Only candidates who qualify in the Entry Test will be eligible to join the onsite classes. As seats are limited, selection will be based on merit.
            </p>
            <p className="mb-3">
              After successfully completing the onsite classes and passing the Final Evaluation Test, eligible candidates will receive the Hunarmand Punjab Scholarship Card, through which they can avail the following benefits:
            </p>
            <div className="mt-3 mb-3">
              <p className="fw-bold mb-2">
                🎓 Scholarship Card Benefits:
              </p>
              <ul className="mb-0">
                <li>Access to Advanced IT Courses</li>
                <li>Monthly Stipend</li>
                <li>Laptop Scheme</li>
                <li>Solar Scheme</li>
                <li>Access to Taleem Finance</li>
                <li>Free Study Abroad Consultancy</li>
                <li>Hands-On Learning with Global Curriculum</li>
                <li>Career Guidance & Freelancing Support</li>
              </ul>
            </div>
            <p className="mb-0 fw-semibold">
              Prepare well for your Entry Test and secure your seat in the onsite classes. Best of luck!
            </p>
          </div>

          {successMsg && (
            <div className="alert alert-success alert-dismissible fade show border-0 shadow-sm mb-4" role="alert">
              <i className="fas fa-check-circle me-2"></i>
              {successMsg}
            </div>
          )}

          <div className="row">
            {/* Sidebar / Overview column */}
            <div className="col-lg-4 mb-4">
              <div className="card border-0 shadow-sm p-4 text-center h-100" style={{ borderRadius: "12px" }}>
                <div className="avatar-section mb-4">
                  <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "80px", height: "80px" }}>
                    <i className="fas fa-user fa-3x"></i>
                  </div>
                  <h4 className="fw-bold mb-1 text-dark">{profile?.fullName}</h4>
                  <span className="badge bg-secondary px-3 py-2 rounded-pill fs-7">{profile?.rollNumber}</span>
                </div>

                <hr className="my-4 text-muted" />

                <div className="info-list text-start">
                  <div className="mb-3">
                    <small className="text-muted d-block uppercase fw-bold" style={{ fontSize: "0.75rem", letterSpacing: "1px" }}>REGISTERED COURSE</small>
                    <span className="text-dark fw-semibold fs-6">
                      <i className="fas fa-book-open me-2 text-success"></i>
                      {profile?.courses?.[0] || "No Course Selected"}
                    </span>
                  </div>
                  <div className="mb-3">
                    <small className="text-muted d-block uppercase fw-bold" style={{ fontSize: "0.75rem", letterSpacing: "1px" }}>CNIC / ID NUMBER</small>
                    <span className="text-dark fw-semibold fs-6">
                      <i className="fas fa-id-card me-2 text-success"></i>
                      {profile?.cnic}
                    </span>
                  </div>
                  <div>
                    <small className="text-muted d-block uppercase fw-bold" style={{ fontSize: "0.75rem", letterSpacing: "1px" }}>EMAIL ADDRESS</small>
                    <span className="text-dark fw-semibold fs-6 text-break">
                      <i className="fas fa-envelope me-2 text-success"></i>
                      {profile?.email}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Edit Form column */}
            <div className="col-lg-8 mb-4">
              <div className="card border-0 shadow-sm p-4" style={{ borderRadius: "12px" }}>
                <h3 className="fw-bold mb-4 text-dark fs-5">
                  <i className="fas fa-user-edit me-2 text-success"></i>
                  Edit Profile Information
                </h3>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Full Name</label>
                      <input
                        type="text"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Father's Name</label>
                      <input
                        type="text"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="fatherName"
                        value={formData.fatherName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Mobile Number</label>
                      <input
                        type="text"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Date of Birth</label>
                      <input
                        type="date"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="dateOfBirth"
                        value={formData.dateOfBirth}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Gender</label>
                      <select
                        className="form-select p-3 border-light-subtle rounded-2"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Qualification</label>
                      <input
                        type="text"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="qualification"
                        value={formData.qualification}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">City</label>
                      <select
                        className="form-select p-3 border-light-subtle rounded-2"
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select City</option>
                        <option value="Lahore (Near by Areas)">Lahore (Near by Areas)</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold text-muted">Permanent Address</label>
                      <input
                        type="text"
                        className="form-control p-3 border-light-subtle rounded-2"
                        name="permanentAddress"
                        value={formData.permanentAddress}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn-green btn btn-success w-100 mt-4 p-3 rounded-2 fw-bold text-white fs-6 shadow-sm"
                    disabled={saving}
                  >
                    {saving ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Saving Changes...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Challans List */}
          <div className="card border-0 shadow-sm p-4 mt-2" style={{ borderRadius: "12px" }}>
            <h3 className="fw-bold mb-4 text-dark fs-5">
              <i className="fas fa-file-invoice-dollar me-2 text-success"></i>
              Entry Test Challan
            </h3>

            {challans.length === 0 ? (
              <div className="text-center py-4 text-muted">
                <i className="fas fa-receipt fa-2x mb-2 text-black-50"></i>
                <p className="mb-0">No challans issued for this registration yet.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle text-center mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Challan No</th>
                      <th>PSID</th>
                      <th>Fee Amount</th>
                      <th>Status</th>
                      <th>Issued Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {challans.map((challan) => (
                      <tr key={challan.challanId}>
                        <td className="fw-bold text-success">{challan.challanId}</td>
                        <td>{challan.psid || (challan.challanId ? `267200309${challan.challanId}` : profile?.psid || "N/A")}</td>
                        <td>Rs. {challan.amount}</td>
                        <td>
                          <span className={`badge px-3 py-2 rounded-pill fw-semibold ${challan.paid
                            ? "bg-success-subtle text-success border border-success-subtle"
                            : "bg-danger-subtle text-danger border border-danger-subtle"
                            }`}>
                            {challan.paid ? "Paid" : "Unpaid"}
                          </span>
                        </td>
                        <td>{new Date(challan.createdAt).toLocaleDateString("en-GB")}</td>
                        <td>
                          <button
                            onClick={() => handleDownloadPDF(challan.challanId)}
                            className="btn btn-sm btn-outline-success px-3 py-2 rounded-2 fw-semibold"
                          >
                            <i className="fas fa-download me-1"></i> Download Challan
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* Payment Instructions Section */}
      {profile && (
        <div
          style={{
            color: "#000",
            padding: "50px 0 80px",
          }}
        >
          <div className="container">
            <div className="payment">
              <h2 className="text-center">Pay Entry Test Fee!</h2>
              <p>
                Now, you're just one step away from confirming your Scholarship
                Card. Please follow the instructions below to submit the
                processing fee through the given payment methods.
              </p>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="text-center p-2 payment-header">
                  Payment Options
                </div>
              </div>
            </div>
            <div className="row payment-options">
              <div className="col-md-12">
                <div className="bg-white p-3 payment-options-container shadow-sm">
                  <div
                    className="row nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <div
                      className="nav-item col-md-6 mb-3 mb-lg-0"
                      role="presentation"
                    >
                      <button
                        className="nav-link active w-100 h-100 p-3"
                        id="pills-home-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                      >
                        <div className="d-flex align-items-start gap-2">
                          <div className="icon">
                            <i className="fa-solid fa-wallet"></i>
                          </div>
                          <div className="ms-3 text-start">
                            <h4>Consumer Number / PSID</h4>
                            <p>
                              Pay using Online Mobile Banking or mobile wallet
                              using 1 Biller
                            </p>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div className="nav-item col-md-6" role="presentation">
                      <button
                        className="nav-link w-100 h-100 p-3"
                        id="pills-profile-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="false"
                      >
                        <div className="d-flex align-items-start gap-2">
                          <div className="icon">
                            <i className="fa-solid fa-building-columns"></i>
                          </div>
                          <div className="ms-3 text-start">
                            <h4>CLICK HERE FOR BANK CHALLAN </h4>
                            <p>
                              Pay at BOP Branch Using Hunarmand Punjab
                              Challan
                            </p>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="tab-content bg-white p-3 rounded-2 shadow-sm"
                        id="pills-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                          tabIndex="0"
                        >
                          <h5>Instructions How to Pay:</h5>
                          {/* Payment Method Tabs */}
                          <div className="mt-4">
                            <ul
                              className="nav nav-tabs border-0"
                              id="paymentTabs"
                              role="tablist"
                              style={{ borderBottom: "1px solid #dee2e6" }}
                            >
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link active border-0"
                                  id="banking-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#banking"
                                  type="button"
                                  role="tab"
                                  aria-controls="banking"
                                  aria-selected="true"
                                  style={{ borderBottom: "2px solid #007bff" }}
                                >
                                  <i className="fas fa-university me-2"></i>
                                  Banking App
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link border-0 d-flex align-items-center"
                                  id="jazzcash-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#jazzcash"
                                  type="button"
                                  role="tab"
                                  aria-controls="jazzcash"
                                  aria-selected="false"
                                >
                                  <img
                                    src="/images/jazzcash.png"
                                    alt="JazzCash"
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      marginRight: "8px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  JazzCash
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link border-0 d-flex align-items-center"
                                  id="easypaisa-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#easypaisa"
                                  type="button"
                                  role="tab"
                                  aria-controls="easypaisa"
                                  aria-selected="false"
                                >
                                  <img
                                    src="/images/Easypaisa.png"
                                    alt="Easypaisa"
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      marginRight: "8px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  Easypaisa
                                </button>
                              </li>
                            </ul>

                            <div
                              className="tab-content my-3"
                              id="paymentTabContent"
                            >
                              {/* Banking App Tab */}
                              <div
                                className="tab-pane fade show active"
                                id="banking"
                                role="tabpanel"
                                aria-labelledby="banking-tab"
                              >
                                <div className="card border-0">
                                  <div className="card-header bg-light border-0">
                                    <h6 className="mb-0">
                                      <i className="fas fa-university me-2"></i>
                                      Banking App Payment
                                    </h6>
                                    <small className="text-muted">
                                      (HBL, Meezan, UBL, Bank Alfalah, etc.)
                                    </small>
                                  </div>
                                  <div className="card-body">
                                    <ol className="ps-3">
                                      <li>Open your bank's mobile app</li>
                                      <li>
                                        Log in with your credentials (MPIN,
                                        fingerprint, or face ID)
                                      </li>
                                      <li>
                                        Go to "Bill Payments" or "Payments"
                                      </li>
                                      <li>
                                        Select "1Bill" (some banks list it under
                                        "Add Biller" or "Pay Bill")
                                      </li>
                                      <li>
                                        Enter the 1Bill Consumer/Invoice Number
                                        (usually 12–15 digits)
                                      </li>
                                      <li>
                                        The system will fetch and display the
                                        bill details
                                      </li>
                                      <li>
                                        Verify the name, amount, and service
                                      </li>
                                      <li>Tap "Pay" or "Confirm"</li>
                                      <li>
                                        Enter your PIN/OTP to authorize the
                                        transaction
                                      </li>
                                      <li>Receive confirmation receipt/SMS</li>
                                    </ol>
                                  </div>
                                </div>
                              </div>

                              {/* JazzCash Tab */}
                              <div
                                className="tab-pane fade"
                                id="jazzcash"
                                role="tabpanel"
                                aria-labelledby="jazzcash-tab"
                              >
                                <div className="card border-0">
                                  <div className="card-header bg-light border-0 d-flex align-items-center">
                                    <img
                                      src="/images/jazzcash.png"
                                      alt="JazzCash"
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "8px",
                                        objectFit: "contain",
                                      }}
                                    />
                                    <h6 className="mb-0">JazzCash Payment</h6>
                                  </div>
                                  <div className="card-body">
                                    <ol className="ps-3">
                                      <li>Open your JazzCash App</li>
                                      <li>Tap on "Pay Bills"</li>
                                      <li>Scroll to and select "1Bill"</li>
                                      <li>
                                        Enter the 1Bill invoice/consumer number
                                      </li>
                                      <li>
                                        Tap "Fetch Bill" — details will appear
                                      </li>
                                      <li>
                                        Confirm the amount and service provider
                                      </li>
                                      <li>Tap "Pay Now"</li>
                                      <li>
                                        Enter your MPIN to complete the payment
                                      </li>
                                      <li>
                                        You'll receive a confirmation
                                        SMS/notification
                                      </li>
                                    </ol>
                                  </div>
                                </div>
                              </div>

                              {/* Easypaisa Tab */}
                              <div
                                className="tab-pane fade"
                                id="easypaisa"
                                role="tabpanel"
                                aria-labelledby="easypaisa-tab"
                              >
                                <div className="card border-0">
                                  <div className="card-header bg-light border-0 d-flex align-items-center">
                                    <img
                                      src="/images/Easypaisa.png"
                                      alt="Easypaisa"
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        marginRight: "8px",
                                        objectFit: "contain",
                                      }}
                                    />
                                    <h6 className="mb-0">Easypaisa Payment</h6>
                                  </div>
                                  <div className="card-body">
                                    <ol className="ps-3">
                                      <li>Open your Easypaisa App</li>
                                      <li>Go to "Pay Bills"</li>
                                      <li>Select the category "1Bill"</li>
                                      <li>Enter the 1Bill invoice number</li>
                                      <li>Tap "Proceed" or "Fetch Bill"</li>
                                      <li>
                                        Verify bill amount and merchant details
                                      </li>
                                      <li>Tap "Confirm & Pay"</li>
                                      <li>Enter your Easypaisa PIN</li>
                                      <li>
                                        You will get a payment confirmation
                                      </li>
                                    </ol>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div>
                            {(profile?.psid || (challans.length > 0 && challans[0].challanId)) && (
                              <div
                                className="alert alert-info"
                                style={{ marginBottom: 16 }}
                              >
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <div>
                                    <strong>Your PSID:</strong>{" "}
                                    <span style={{ fontFamily: "monospace", fontSize: "1.1em" }}>
                                      {challans.length > 0 && challans[0].challanId
                                        ? `267200309${challans[0].challanId}`
                                        : profile.psid}
                                    </span>
                                  </div>
                                  <button
                                    className="btn btn-sm btn-outline-success ms-3"
                                    onClick={() => {
                                      const val = challans.length > 0 && challans[0].challanId
                                        ? `267200309${challans[0].challanId}`
                                        : profile.psid;
                                      navigator.clipboard.writeText(val);
                                      alert("PSID copied to clipboard!");
                                    }}
                                    title="Copy PSID"
                                  >
                                    <i className="fa fa-copy"></i>
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="pills-profile"
                          role="tabpanel"
                          aria-labelledby="pills-profile-tab"
                          tabIndex="0"
                        >

                          <h5>Follow these steps to complete your payment:</h5>
                          <h5>For Bank Challan Payment:</h5>
                          <ol>
                            <li>
                              Download and print your generated Challan from the table above.
                            </li>
                            <li>
                              Pay the challan at BOP Bank Branch to complete your payment, confirm your Enrollment & Get a chance to avail Scholarship Card.
                            </li>
                          </ol>



                          <div>
                            {(profile?.psid || (challans.length > 0 && challans[0].challanId)) && (
                              <div
                                className="alert alert-info"
                                style={{ marginBottom: 16 }}
                              >

                                {challans.length > 0 && (
                                  <div className="d-flex align-items-center justify-content-between pt-2">
                                    <div>
                                      <strong>Your Challan No:</strong>{" "}
                                      <span style={{ fontFamily: "monospace", fontSize: "1.1em" }}>
                                        {challans[0].challanId}
                                      </span>
                                    </div>
                                    <button
                                      className="btn btn-sm btn-outline-success ms-3"
                                      onClick={() => {
                                        navigator.clipboard.writeText(challans[0].challanId);
                                        alert("Challan No copied to clipboard!");
                                      }}
                                      title="Copy Challan No"
                                    >
                                      <i className="fa fa-copy"></i>
                                    </button>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnsiteDashboard;
